import type { AxiosInstance } from 'axios'
import * as R from 'ramda'

import { UserInterface } from '../../interfaces/user'

export const searchUsers = (api: AxiosInstance) => async ({
  queryKey
}: {
  queryKey: string[]
}): Promise<UserInterface[]> => {
  if (R.isEmpty(queryKey[1])) return []
  const { data } = await api.get(`/v1.0/admin/users/search/${queryKey[1]}`)
  return data
}
